// @flow
import React from 'react';
import { SvgXml } from 'react-native-svg';
import {
    Platform,
} from 'react-native';

const styles = {
    first: {
        fill: 'none',
        stroke: '#adafb5',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
    },
    second: {
        fill: 'none',
        stroke: '#b6cd47',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
    },
    noneStyle: {
        fill: 'none',
    },
};
const xml = `<svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 60 60"
        >
        <g
         id="Layer_2" data-name="Layer 2"
         >
        <g 
        id="Layer_1-2" data-name="Layer 1"
        >
        <rect
        width="60" height="60" style="fill:none"
        />
        <path
         d="M23.32,23.94h-1l-1,3.11c-.21.08-.42.16-.62.26l-2.85-1.46-2,2,
         1.44,2.84a5.88,5.88,0,0,0-.3.73l-3,1v2.84l3,1a5.77,5.77,0,0,0,
         .34.81l-1.39,2.71,2,2,2.77-1.41a5.4,5.4,0,0,0,.82.33l.94,2.9h2.84l1-3a7.8,7.8,0,0,0,
         .72-.31l2.78,1.41,2-2-1.14-2.23"
         style={styles.first}/>
         <path 
         d="M27.26,35.38a3.87,3.87,0,1,1-3.53-5.44"
         style={styles.first}
         />
         <path d="M46,27.61V24.77l-3.17-1c-.07-.18-.15-.36-.23-.53l1.49-2.92-2-2-3,1.51a4.33,
         4.33,0,0,0-.54-.21l-1-3.12H34.71l-1,3.12c-.21.07-.42.16-.62.25l-2.85-1.45-2,2,1.44,
         2.83c-.11.24-.21.48-.3.73l-3,1v2.84l3,1a7.27,7.27,0,0,0,.34.81l-1.38,2.72,2,2,2.77-1.41a6.38,
         6.38,0,0,0,.82.33l.94,2.9h2.84l1-3a7.84,7.84,0,0,0,.72-.32l2.78,1.42,2-2L42.7,29.23a6.62,
         6.62,0,0,0,.24-.62Zm-6-1.28a3.87,3.87,0,1,1-3.87-3.87A3.87,3.87,0,0,1,40,26.33Z"
                  style={styles.second}/>
        </g>
    </g>
</svg>
`;

const LoginIcon = (): React.Node => (
    Platform.OS === 'web' ? (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 60 60"
            width="170"
            height="120"
        >
            <g
                id="Layer_2"
                data-name="Layer 2"
            >
                <g
                    id="Layer_1-2"
                    data-name="Layer 1"
                >
                    <rect
                        width="100"
                        height="100"
                        style={styles.noneStyle}
                    />
                    <path
                        d="M23.32,23.94h-1l-1,3.11c-.21.08-.42.16-.62.26l-2.85-1.46-2,2,
         1.44,2.84a5.88,5.88,0,0,0-.3.73l-3,1v2.84l3,1a5.77,5.77,0,0,0,
         .34.81l-1.39,2.71,2,2,2.77-1.41a5.4,5.4,0,0,0,.82.33l.94,2.9h2.84l1-3a7.8,7.8,0,0,0,
         .72-.31l2.78,1.41,2-2-1.14-2.23"
                        style={styles.first}
                    />
                    <path
                        d="M27.26,35.38a3.87,3.87,0,1,1-3.53-5.44"
                        style={styles.first}
                    />
                    <path
                        d="M46,27.61V24.77l-3.17-1c-.07-.18-.15-.36-.23-.53l1.49-2.92-2-2-3,1.51a4.33,
         4.33,0,0,0-.54-.21l-1-3.12H34.71l-1,3.12c-.21.07-.42.16-.62.25l-2.85-1.45-2,2,1.44,
         2.83c-.11.24-.21.48-.3.73l-3,1v2.84l3,1a7.27,7.27,0,0,0,.34.81l-1.38,2.72,2,2,2.77-1.41a6.38,
         6.38,0,0,0,.82.33l.94,2.9h2.84l1-3a7.84,7.84,0,0,0,.72-.32l2.78,1.42,2-2L42.7,29.23a6.62,
         6.62,0,0,0,.24-.62Zm-6-1.28a3.87,3.87,0,1,1-3.87-3.87A3.87,3.87,0,0,1,40,26.33Z"
                        style={styles.second}
                    />
                </g>
            </g>
        </svg>
    ) : (
        <SvgXml xml={xml} />
    )
);

export default LoginIcon;
